function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48 43.0156C48 45.777 45.7614 48.0156 43 48.0156H17V48.0171H16V48.0156H5C2.23858 48.0156 0 45.7771 0 43.0156V5.01563C0 2.2542 2.23858 0.015625 5 0.015625H43C45.7614 0.015625 48 2.2542 48 5.01562V43.0156ZM24 1.01562H5C2.79086 1.01562 1 2.80649 1 5.01563V31.5156H24L24 1.01562ZM25 31.5156H47V5.01562C47 2.80649 45.2091 1.01562 43 1.01562H25L25 31.5156ZM1 32.5156V43.0156C1 45.2248 2.79086 47.0156 5 47.0156H16V32.5156H1ZM17 32.5156V47.0156H33V32.5156H17ZM34 32.5156V47.0156H43C45.2091 47.0156 47 45.2248 47 43.0156V32.5156H34Z",
  fill: "#C1C6C9"
});

var Svg5A = function Svg5A(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg5A, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/5a.df665d32.svg";
export { ForwardRef as ReactComponent };